import React from "react";
import { Navigate, Outlet } from "react-router-dom";

/**
 * Componente de rota protegida que verifica se o usuário está autenticado.
 * Caso contrário, redireciona para a página de login.
 */
const ProtectedRoute = () => {
  const isAuthenticated = !!localStorage.getItem("access_token"); // Verifica se há um token salvo

  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
